import {BuyerDataError} from './BuyerDataError.js'
import {ConfirmAgreedPriceTransactionsError} from './ConfirmAgreedPriceTransactionsError.js'
import {CreateTradeTransactionsError} from './CreateTradeTransactionsError.js'
import {GetBuyerTradeDataTransactionsError} from './GetBuyerTradeDataTransactionsError.js'
import {GetProfessionalActivitiesTransactionsError} from './GetProfessionalActivitiesTransactionsError.js'
import {GetSellerTradeDataTransactionsError} from './GetSellerTradeDataTransactionsError.js'
import {GetTradeCostsListTransactionsError} from './GetTradeCostsListTransactionsError.js'
import {GetTradeDataTransactionsError} from './GetTradeDataTransactionsError.js'
import {InformAgreedPriceTransactionsError} from './InformAgreedPriceTransactionsError.js'
import {PayOutError} from './PayOutError.js'
import {ReservationIdError} from './ReservationIdError.js'
import {TransactionError} from './TransactionError.js'
import {TransactionNoContentError} from './TransactionNoContentError.js'
import {UpdateBuyerTradeDataTransactionsError} from './UpdateBuyerTradeDataTransactionsError.js'
import {UpdateSellerTradeDataTransactionsError} from './UpdateSellerTradeDataTransactionsError.js'
import {UploadBuyerIdTransactionsError} from './UploadBuyerIdTransactionsError.js'
import {UploadSellerIdTransactionsError} from './UploadSellerIdTransactionsError.js'
import {UserFormError} from './UserFormError.js'

export class TransactionErrorsFactory {
  static createTradeTransactionsError = msg => new CreateTradeTransactionsError(msg)
  static transactionError = msg => new TransactionError(msg)
  static buyerDataError = msg => new BuyerDataError(msg)
  static confirmAgreedPriceTransactionsError = msg => new ConfirmAgreedPriceTransactionsError(msg)
  static informAgreedPriceTransactionsError = msg => new InformAgreedPriceTransactionsError(msg)
  static getBuyerTradeDataTransactionsError = msg => new GetBuyerTradeDataTransactionsError(msg)
  static getSellerTradeDataTransactionsError = msg => new GetSellerTradeDataTransactionsError(msg)
  static getProfessionalActivitiesTransactionsError = msg => new GetProfessionalActivitiesTransactionsError(msg)
  static getTradeCostsListTransactionsError = msg => new GetTradeCostsListTransactionsError(msg)
  static getTradeDataTransactionsError = msg => new GetTradeDataTransactionsError(msg)
  static transactionNoContentError = msg => new TransactionNoContentError(msg)
  static payOutError = msg => new PayOutError(msg)
  static userFormError = msg => new UserFormError(msg)
  static reservationIdError = msg => new ReservationIdError(msg)
  static updateBuyerTradeDataTransactionsError = msg => new UpdateBuyerTradeDataTransactionsError(msg)
  static updateSellerTradeDataTransactionsError = msg => new UpdateSellerTradeDataTransactionsError(msg)
  static uploadBuyerIdTransactionsError = msg => new UploadBuyerIdTransactionsError(msg)
  static uploadSellerIdTransactionsError = msg => new UploadSellerIdTransactionsError(msg)
}
